module.exports = __webpack_public_path__ + "img/Picture3.66c82b5e.png";